import apiInstance from "../config/api/axios";
export const getDocRequestsService = async () => {
  try {
    const response = await apiInstance.get(
      "/doc-requests/v1/service-types"
    );
    return response.data;
  } catch (error) {
    console.error(
      "getDocRequests error:",
      error?.response?.data || error
    );

    throw new Error(
      error?.response?.data?.message ||
        "Failed to fetch document requests."
    );
  }
};
export const getDocRequestsServiceById = async (id) => {
  try {
    const response = await apiInstance.get(
      `/doc-requests/v1/service-types/${id}`
    );

    

    return response.data;
  } catch (error) {
    console.error(
      "getDocRequestsServiceById error:",
      error?.response?.data || error
    );

    throw new Error(
      error?.response?.data?.message ||
        "Failed to fetch document service details."
    );
  }
};
export const submitDocumentrequests = async (payload) => {
 
  try {
    
    const response = await apiInstance.post(
      "/doc-requests/v1/document-requests",
      JSON.stringify(payload),
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "submitDocumentrequests error:",
      error?.response?.data || error
    );

    throw new Error(
      error?.response?.data?.message ||
        "Failed to submit document request."
    );
  }
};
export const getDocumentrequests = async (
  page = 1,
  limit = 10,
  filters = {}
) => {
  try {
    const params = {
      page,
      limit,
    };

    // Add only non-empty filters
    if (filters.service_request_no?.trim()) {
      params.service_request_no = filters.service_request_no.trim();
    }
    if (filters.status) {
      params.status = filters.status;
    }

    if (filters.service_type_id) {
      params.service_type_id = filters.service_type_id;
    }

    if (filters.from_date) {
      params.from_date = filters.from_date;
    }

    if (filters.to_date) {
      
      params.to_date = filters.to_date;
    }

    // Add loan number filter
    if (filters.loan_number?.trim()) {
      params.loan_number = filters.loan_number.trim();
    }

    const response = await apiInstance.get(
      "/doc-requests/v1/document-requests",
      {
        params,
      }
    );



    return response.data;
  } catch (error) {
    console.error(
      "getDocRequests error:",
      error?.response?.data || error
    );

    throw new Error(
      error?.response?.data?.message ||
        "Failed to fetch document requests."
    );
  }
};

export const getDocumentrequestsByid = async (payload) => {
  
  try {
    const response = await apiInstance.get(
      `doc-requests/v1/document-requests/${payload}`
    );

    

    return response.data;
  } catch (error) {
    console.error(
      "getDocRequests error:",
      error?.response?.data || error
    );

    throw new Error(
      error?.response?.data?.message ||
        "Failed to fetch document requests."
    );
  }
};

export const updateDocumentRequestStatus = async (
  id,
  payload
) => {
  try {
    const response = await apiInstance.patch(
      `/doc-requests/v1/document-requests/${id}/status`,
      payload
    );

 

    return response.data;
  } catch (error) {
    console.error(
      "updateDocumentRequestStatus error:",
      error?.response?.data || error
    );

    throw new Error(
      error?.response?.data?.message ||
        "Failed to update document request status."
    );
  }
};


export const getLoanList = async () => {
  try {
    const statuses = "0,1,2,3,4,5,6,7,8,9,10,11,12";

    const response = await apiInstance.get(
      `/lmsloanlist?statuses=${statuses}`
    );

    

    return response.data;
  } catch (error) {
    console.error(
      "getLoanList error:",
      error?.response?.data || error
    );

    throw new Error(
      error?.response?.data?.message ||
        "Failed to fetch loan list."
    );
  }
};
